/**
 * Containerul in care ruleaza pagina: browserul incorporat al unei aplicatii (WebView) sau un
 * browser obisnuit. Se pune ca proprietate pe telemetrie (`inAppBrowser`), ca erorile NOASTRE din
 * WebView-ul Facebook sa poata fi separate de restul — masurat 07.10: 22% din sesiunile de OTP
 * ruleaza acolo.
 *
 * 🔴 E o ETICHETA, nu un filtru. Zgomotul injectat de aplicatia-gazda se recunoaste dupa continutul
 * erorii (`esteZgomotTerta`, `telemetry/envelope.ts`), niciodata dupa user agent: altfel am arunca
 * si erorile noastre, exact din containerul in care avem cea mai mare nevoie de ele.
 *
 * Modul pur, fara `navigator`: apelantul da sirul, deci se testeaza pe `environment: 'node'`.
 */

export type BrowserInApp = 'facebook' | 'instagram' | 'tiktok' | 'none';

/** Instagram INAINTEA Facebook: UA-ul Instagram de pe iOS poarta si markeri `FBAN`/`FBAV`. */
const INSTAGRAM = /Instagram/;
/** `musical_ly` e numele vechi al aplicatiei, ramas in UA; `BytedanceWebview` e motorul ei. */
const TIKTOK = /musical_ly|BytedanceWebview|TikTok/;
/** Messenger (`FBAN/MessengerForiOS`, `FB_IAB/MESSENGER`, `FB_IAB/Orca-Android`) intra tot aici. */
const FACEBOOK = /FBAN|FBAV|FB_IAB|FBIOS/;

export function detecteazaBrowserInApp(userAgent: string): BrowserInApp {
    if (!userAgent) return 'none';
    if (INSTAGRAM.test(userAgent)) return 'instagram';
    if (TIKTOK.test(userAgent)) return 'tiktok';
    if (FACEBOOK.test(userAgent)) return 'facebook';
    return 'none';
}
